import axios from "axios";
import { getAuthToken } from "../utils/authToken";

export const baseUrl = "https://backtoreality-api.codebnb.me/";

let isRefreshing = false;
let subscribers = [];
async function responseFailureInterceptionHandler(error) {
  const originalConfig = error.config;

  // if (error.response.status === 401) {
  //   try {
  //     if (!isRefreshing) {
  //       isRefreshing = true;
  //       refresh_req().then(async (response) => {
  //         const { access_token } = response.data;
  //         localStorage.setItem("token", access_token);
  //         //  localStorage.setItem("refresh", refresh);
  //         subscribers.map((cb) => {
  //           cb(access_token);
  //         });
  //         subscribers = [];
  //         isRefreshing = false;
  //       });
  //     }

  //     return new Promise((resolve) => {
  //       subscribers.push((token) => {
  //         originalConfig.headers.Authorization = `${token}`;

  //         resolve(axiosInstanceConfig(originalConfig));
  //       });
  //     });
  //   } catch (_error) {
  //     isRefreshing = false;
  //     return Promise.reject();
  //   }
  // }

  return Promise.reject(error);
}
export const axiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 60000,
  headers: {
    Accept: "application/json",
  },
});
export const axiosInstanceConfig = axios.create({
  baseURL: baseUrl,
  timeout: 60000,
});

const successResponse = (response) => response;

const errorResponse = (error) => Promise.reject(error);
const setHeaders = async (reqConfig) => {
  reqConfig.headers["Content-Type"] = "application/json";
  return reqConfig;
};
const setHeadersConfig = async (reqConfig) => {
  reqConfig.headers.Authorization = getAuthToken();

  return reqConfig;
};

axiosInstance.interceptors.response.use(successResponse, errorResponse);
axiosInstance.interceptors.request.use(setHeaders);
axiosInstanceConfig.interceptors.response.use(
  successResponse,
  responseFailureInterceptionHandler
);
axiosInstanceConfig.interceptors.request.use(setHeadersConfig);
